import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import React from 'react';
import { ContentRenderer } from '../ui/ContentRenderer';

/*
  Sidor i admin visar bara komponenter!
  Fyll i så du kan spara och lägg sen till komponenter!
*/

function ContentPage(props) {
  const { page } = props;

  return (
    <>
      {page ? (
        <>
          {page?.data?.items && (
            <ContentRenderer items={page?.data?.items ?? []} />
          )}
        </>
      ) : (
        <LoadingLine
          heightPx={14}
          widthRem={30}
          randomizeWidthBy={10}
          count={10}
          style={{
            marginBottom: '12px',
          }}
        />
      )}
    </>
  );
}

export default ContentPage;
